module.exports = __webpack_public_path__ + "fonts/SamsungOne-400_v1.1.39388fba.ttf";